import React, { useEffect, useState } from 'react';
import { api } from '../../utils/api';
import './Admin.css';

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [recentInquiries, setRecentInquiries] = useState([]);

  useEffect(() => {
    Promise.all([
      api.getPerformances(),
      api.getInquiryStats(),
      api.getAllNotices(),
      api.getClients(),
      api.getInquiries(),
    ]).then(([perfs, inquiryStats, notices, clients, inquiries]) => {
      setStats({
        performances: perfs.length,
        inquiries_total: inquiryStats.total,
        inquiries_unread: inquiryStats.unread,
        notices: notices.length,
        clients: clients.length,
      });
      setRecentInquiries(inquiries.slice(0, 5));
    }).catch(() => {});
  }, []);

  const STATUS_LABEL = { unread: '미확인', read: '확인', replied: '답변완료' };

  return (
    <div>
      <div className="admin-page-header">
        <div className="admin-page-title">대시보드</div>
        <div className="admin-page-sub">한길에이아이 홈페이지 현황</div>
      </div>

      {stats && (
        <div className="admin-stats-grid">
          <div className="admin-stat-card">
            <div className="admin-stat-label">감리 실적</div>
            <div className="admin-stat-value">{stats.performances}건</div>
          </div>
          <div className="admin-stat-card">
            <div className="admin-stat-label">미확인 문의</div>
            <div className={`admin-stat-value ${stats.inquiries_unread > 0 ? 'danger' : ''}`}>
              {stats.inquiries_unread}건
            </div>
          </div>
          <div className="admin-stat-card">
            <div className="admin-stat-label">전체 문의</div>
            <div className="admin-stat-value">{stats.inquiries_total}건</div>
          </div>
          <div className="admin-stat-card">
            <div className="admin-stat-label">공지사항</div>
            <div className="admin-stat-value">{stats.notices}건</div>
          </div>
          <div className="admin-stat-card">
            <div className="admin-stat-label">고객사</div>
            <div className="admin-stat-value">{stats.clients}개</div>
          </div>
        </div>
      )}

      <div className="admin-card">
        <div className="admin-page-title" style={{ fontSize: '1rem', marginBottom: 16 }}>
          최근 문의
        </div>
        {recentInquiries.length === 0 ? (
          <p style={{ color: '#64748b', fontSize: '0.875rem' }}>문의가 없습니다.</p>
        ) : (
          <div className="admin-table-wrap">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>이름</th>
                  <th>이메일</th>
                  <th>회사</th>
                  <th>상태</th>
                  <th>접수일시</th>
                </tr>
              </thead>
              <tbody>
                {recentInquiries.map((inq) => (
                  <tr key={inq.id}>
                    <td>{inq.name}</td>
                    <td>{inq.email}</td>
                    <td>{inq.company || '-'}</td>
                    <td>
                      <span className={`badge badge-${inq.status}`}>
                        {STATUS_LABEL[inq.status]}
                      </span>
                    </td>
                    <td>{new Date(inq.created_at).toLocaleString('ko-KR')}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
